module.exports = __webpack_public_path__ + "static/img/industryplat.e34206fc.png";